import { GET_BANNERS_START } from '../../types';

export const get_banners = (payload) => ({
  type: GET_BANNERS_START,
  payload,
});
